import JsonLd from './JsonLd';

/**
 * FAQPage JSON-LD. Pass a flat array of {question, answer} objects.
 * Google renders these as expandable rich results in search.
 *
 * AI engines (ChatGPT, Perplexity, Gemini) treat FAQPage schema as
 * authoritative Q&A and frequently quote/cite from it directly.
 */
export default function FAQSchema({ faqs }) {
  if (!faqs || faqs.length === 0) return null;

  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };

  return <JsonLd id="faq" data={data} />;
}
